[
  {
    "code": "CF-BB",
    "name": "Bamingui-Bangoran"
  },
  {
    "code": "CF-BGF",
    "name": "Bangui"
  },
  {
    "code": "CF-BK",
    "name": "Basse-Kotto"
  },
  {
    "code": "CF-HM",
    "name": "Haut-Mbomou"
  },
  {
    "code": "CF-HK",
    "name": "Haute-Kotto"
  },
  {
    "code": "CF-KG",
    "name": "Kémo"
  },
  {
    "code": "CF-LB",
    "name": "Lobaye"
  },
  {
    "code": "CF-HS",
    "name": "Mambéré-Kadéï"
  },
  {
    "code": "CF-MB",
    "name": "Mbomou"
  },
  {
    "code": "CF-KB",
    "name": "Nana-Grébizi"
  },
  {
    "code": "CF-NM",
    "name": "Nana-Mambéré"
  },
  {
    "code": "CF-MP",
    "name": "Ombella-Mpoko"
  },
  {
    "code": "CF-UK",
    "name": "Ouaka"
  },
  {
    "code": "CF-AC",
    "name": "Ouham"
  },
  {
    "code": "CF-OP",
    "name": "Ouham-Pendé"
  },
  {
    "code": "CF-SE",
    "name": "Sangha-Mbaéré"
  },
  {
    "code": "CF-VK",
    "name": "Vakaga"
  }
]